import { render, staticRenderFns } from "./register.component.vue?vue&type=template&id=39fc3d46&"
import script from "./register.component.vue?vue&type=script&lang=ts&"
export * from "./register.component.vue?vue&type=script&lang=ts&"
import style0 from "./register.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "register.component.vue"
export default component.exports